// extracted by mini-css-extract-plugin
export default {"wrapper":"WizardDiscussion_wrapper__l0L7g","header":"WizardDiscussion_header__Vre2M"};